import { Controller } from "stimulus"

let nextFieldIndex = Date.now()

export default class extends Controller {
  add(event) {
    event.preventDefault()

    const element = event.currentTarget
    const html = this.templateFor(element)
    element.insertAdjacentHTML("beforebegin", html)
    if (element.dataset.nestedFieldsFocus === "true") {
      element.previousElementSibling.querySelector('input:not([type="hidden"])').focus()
    }
  }

  addToTable(event) {
    event.preventDefault()

    const table = event.currentTarget.closest("table")
    const tbody = table && table.querySelector("tbody")

    if (tbody) {
      tbody.insertAdjacentHTML("afterbegin", this.templateFor(event.currentTarget))
    }
  }

  remove(event) {
    event.preventDefault()

    this.markForDestroy(event.currentTarget)
    this.hideClosest(event.currentTarget, "fieldset")
  }

  removeTableRow(event) {
    event.preventDefault()

    this.markForDestroy(event.currentTarget)
    this.hideClosest(event.currentTarget, "tr")
  }

  templateFor(element) {
    const id = element.dataset.nestedFieldsId
    const template = element.dataset.nestedFieldsTemplate
    const replacement = String(++nextFieldIndex)

    const fragment = document.createElement("template")
    fragment.innerHTML = template.replace(new RegExp(id, "g"), replacement)
    fragment.content.querySelectorAll('input[name$="[revision_key]"]').forEach(input => {
      input.value = this.rowIdentity()
    })
    return fragment.innerHTML
  }

  rowIdentity() {
    if (typeof crypto.randomUUID === "function") return crypto.randomUUID()

    const bytes = crypto.getRandomValues(new Uint8Array(16))
    bytes[6] = (bytes[6] & 0x0f) | 0x40
    bytes[8] = (bytes[8] & 0x3f) | 0x80
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("")
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
  }

  markForDestroy(element) {
    const destroyField = element.previousElementSibling

    if (destroyField && destroyField.type === "hidden") {
      destroyField.value = "1"
    }
  }

  hideClosest(element, selector) {
    const container = element.closest(selector)

    if (container) {
      container.style.display = "none"
    }
  }
}
